import { render, staticRenderFns } from "./packageForm.vue?vue&type=template&id=25e090e8&scoped=true"
import script from "./packageForm.vue?vue&type=script&lang=js"
export * from "./packageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e090e8",
  null
  
)

export default component.exports